import { pauseAllProgressBars, resumeAllProgressBars } from '@/modules/actions/headerLineDuration';
// 別タブ移動時の処理
export const visibilityChangeAction = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      // ユーザーが現在のタブを離れた場合
      pauseAllProgressBars(); // 進捗バーを一時停止
    } else {
      // ユーザーが現在のタブに戻った場合
      const videoControl = document.querySelector('.storeeel-video-control');
      if (videoControl && videoControl.alt === 'pause') {
        resumeAllProgressBars(); // 進捗バーを再開
      }
    }
  });
}
